import React from "react";
import PropTypes from "prop-types";
import { RelatedStories } from "../../story-page-components/related-stories";
import { AdService } from "../../ad-service";
import "./sidebar.module.css";

export const Sidebar = ({ story, showAd, template, wide }) => (
  <>
    {!showAd ? null : (
      <div styleName="ad">
        <AdService adtype="Story-Mrec" />
      </div>
    )}
    <RelatedStories template={template} story={story} wide={wide} />
  </>
);

Sidebar.propTypes = {
  story: PropTypes.object,
  showAd: PropTypes.bool,
  template: PropTypes.string,
  wide: PropTypes.bool
};
